// extracted by mini-css-extract-plugin
export default {"body":"audio-text_body__dPVc6","input":"audio-text_input__Fw20W","content":"audio-text_content__gLnu6","table":"audio-text_table__DL3mI"};